import { useState } from 'react';
import { StateSnapshot } from 'react-virtuoso';
import { type GameServiceListGamesData } from '@/api';

export const useGamesStore = () => {
    const [filters, setFilters] = useState<GameServiceListGamesData>();
    const [tableState, setTableState] = useState<StateSnapshot>();

    return {
        filters,
        tableState,

        setFilters,
        setTableState,
    };
};
